module.exports = __webpack_public_path__ + "static/media/google-analytics.fd265721.png";